import Vue from 'vue';

const sendMsg = (message, type, title = undefined, onClick = undefined, onClose = undefined, duration = 4500) => {
    Vue.prototype.$notify({
        type: type,
        message: message,
        title: title,
        dangerouslyUseHTMLString: true,
        onClick: onClick,
        onClose: onClose,
        duration: duration
    });
};

class Notification {
    success(message, title, onClick, onClose, duration) {
        sendMsg(message, 'success', title, onClick, onClose, duration);
    }

    warning(message, title, onClick, onClose, duration) {
        sendMsg(message, 'warning', title, onClick, onClose, duration);
    }

    info(message, title, onClick, onClose, duration) {
        sendMsg(message, 'info', title, onClick, onClose, duration);
    }

    error(message, title, onClick, onClose, duration) {
        sendMsg(message, 'error', title, onClick, onClose, duration);
    }
}

export const notification = new Notification();
